/* 
	<template>
		// 使用state标签，定义字典名称dict、值value
		<c-state dict="dictName" value="1"></c-state>
		// 使用异步数据定义async属性
		<c-state dict="dictName" async value="1"></c-state>
		
		// 下拉框、单复选框直接使用下面引入的选项数据
		<c-select :options="dictName"></c-select>
		<c-radio-group :options="dictName"></c-radio-group>
		<c-checkbox-group :options="dictName"></c-checkbox-group>
	</template>

	<script>
		// 获取本地选项数据
		// 导入mapState方法
		import {mapState} from 'vuex'
		export default {
			computed: {
				// 获取dictName选项数据
				...mapState(['dictName'])
			}
		}
		
		// 获取异步选项数据
		// 导入asyncMapState方法
		import {asyncMapState} from '@/store'
		export default {
			computed: {
				// 获取dictName选项数据
				...asyncMapState(['dictName'])
			}
		}
	</script>
 */

/* 支持颜色
 * gray 灰色
 * blue 蓝色
 * red 红色
 * green 绿色
 * yellow 黄色
 * orange 橙色
 */

export default {
	dictName: [{
		name: '状态1',
		value: 1,
		color: 'blue'
	}, {
		name: '状态2',
		value: 2,
		color: 'red'
	}],

	paperSize: [{
		name: 'A3',
		value: '29.7x42'
	}, {
		name: 'A4',
		value: '21x29.7'
	}, {
		name: 'A5',
		value: '14.8x21'
	}, {
		name: '自定义',
		value: 'auto'
	}],
	
	fieldType: [{
		name: '文本',
		value: 'text'
	}, {
		name: '数字',
		value: 'number'
	}, {
		name: '时间',
		value: 'time'
	}, {
		name: '选项',
		value: 'option'
	}, {
		name: '附件',
		value: 'file'
	}, {
		name: '图片',
		value: 'image'
	// }, {
	// 	name: '公式',
	// 	value: 'formula'
	}],
	// 启用/停用
	disableEnableDic: [{
		name: '启用',
		value: 1,
		color: 'green'
	}, {
		name: '禁用',
		value: 2,
		color: 'gray'
	}],
	// 启用/停用
	completedDic: [{
		name: '已完成',
		value: 1,
		color: 'green'
	}, {
		name: '未完成',
		value: 0,
		color: 'red'
	}],
	//关闭、开启
	openCloseDic: [{
		name: '关闭',
		value: 0,
		color: 'gray'
	}, {
		name: '开启',
		value: 1,
		color: 'red'
	}],
	//允许不允许
	allowDisallowDic: [{
		name: '不允许',
		value: 0,
		color: 'gray'
	}, {
		name: '允许',
		value: 1,
		color: 'red'
	}],
	//默认
	defaultDic: [{
		name: '',
		value: 1,
		color: 'gray'
	}, {
		name: '默认',
		value: 2,
		color: 'green'
	}],

	//模板类型名称
	templateTypeName: [{
		name: '内置模板',
		value: 1,
		color: 'green'
	}, {
		name: 'Excel模板',
		value: 2,
		color: 'blue'
	}, {
		name: 'Excel模板',
		value: 3,
		color: 'brown'
	}],
	// 单据状态
	orderStateDic: [{
		name: '未开始',
		value: 1,
		color: 'gray'
	}, {
		name: '执行中',
		value: 2,
		color: 'blue'
	}, {
		name: '已结束',
		value: 3,
		color: 'green'
	}, {
		name: '已取消',
		value: 4,
		color: 'orange'
	}],
	// 单据状态(不含取消)
	orderStateNoCancelDic: [{
		name: '未开始',
		value: 1,
		color: 'gray'
	}, {
		name: '执行中',
		value: 2,
		color: 'blue'
	}, {
		name: '已结束',
		value: 3,
		color: 'green'
	}],
	//审核状态（含待提交）
	auditStateDic:[
		{
			name: '待提交',
			value: 0,
			color: 'gray'
		}, {
			name: '待审核',
			value: 1,
			color: 'blue'
		}, {
			name: '已审核',
			value: 2,
			color: 'green'
		}
	],
	//审核状态
	auditState2Dic:[
		{
			name: '待审核',
			value: 1,
			color: 'blue'
		}, {
			name: '已审核',
			value: 2,
			color: 'green'
		}
	],
	//审批状态
	approveStateDic:[
		{name: '待审批', value: 1, color: 'gray'},
		{name: '已审批', value: 2, color: 'green'}
	],

	//系统操作类型
	operationName:[
		{name: '创建', value: 1, color: 'green'},
		{name: '编辑', value: 2, color: 'blue'},
		{name: '删除', value: 3, color: 'red'},
		{name: '导出数据', value: 4, color: 'green'},
		{name: '导入数据', value: 5, color: 'blue'},
		{name: '接受', value: 6, color: 'green'},
		{name: '驳回', value: 7, color: 'red'},
	],

	//导入操作状态
	importStateName:[
		{name: '导入失败', value: 0, color: 'red'},
		{name: '部分成功', value: 1, color: 'yellow'},
		{name: '导入成功', value: 2, color: 'green'}
	],

	//报表时间粒度
	timeGranule: [{
		name: '每天',
		value: 'DAY'
	}, {
		name: '每周',
		value: 'WEEK'
	}, {
		name: '每月',
		value: 'MONTH'
	}, {
		name: '无',
		value: 'ALL'
	}],

	//检验状态(不含免检)
	testStateQualityDic: [{
		name: '未质检',
		value: 2,
		color: 'orange'
	}, {
		name: '已质检',
		value: 3,
		color: 'green'
	}],
	rejectStateDic:[{
		name: '被驳回中',
		value: 1,
		color: 'red'
	},{
		name: '已调出',
		value: 2,
		color: 'blue'
	}],

	//用户类型
	userTypeDic: [
		{name: '员工',value: 1,color: 'blue'},
		{name: '供应商联系人',value: 2,color: 'gray'},
	],
	//数据权限范围
	dataScopeDic: [
		{name: '个人',value: 1,color: 'blue'},
		{name: '部门',value: 2,color: 'green'},
		{name: '全部',value: 3,color: 'orange'},
	],
	//库存分布统计类型
	summaryTypeDic: [
		{name: '按机型维度',value: 1,color: 'blue'},
		{name: '按人员维度',value: 2,color: 'green'},
	],
	//支付方式
	payMethodDic: [
		{name: '微信',value: 'wxpay_scan',color: 'green'},
		{name: '支付宝',value: 'alipay_scan',color: 'gray'},
		{name: '银行卡',value:'bankcard',color: 'blue'}
	],
	//账户锁定状态
	lockStateDic: [{
		name: '正常',
		value: 0,
		color: 'green'
	}, {
		name: '已锁定',
		value: 1,
		color: 'red'
	}],
	materialProcessMethodDic: [{
		name: '外发后手动前往委外单发料',
		value: 0,
		color: 'red'
	},{
		name: '外发后自动生成发料动态',
		value: 1,
		color: 'green'
	}],
	mobileTypeDic:[{
		name: 'H5网页',
		value: 1,
		color: 'gray'
	}, {
		name: '微信小程序',
		value: 2,
		color: 'green'
	}],

	isManageDic:[{
		name: '管理员',
		value: 1,
		color: 'green'
	}, {
		name: '普通用户',
		value: 2,
		color: 'gray'
	}],
	productStateDic: [{
		name: '待绑定',
		value: 0,
		color: 'gray'
	}, {
		name: '采购待入库',
		value: 1,
		color: 'green'
	}, {
		name: '销售退货待入库',
		value: 2,
		color: 'blue'
	}, {
		name: '在库',
		value: 10,
		color: 'gray'
	}, {
		name: '质检调拨中',
		value: 11,
		color: 'blue'
	}, {
		name: '质检中',
		value: 12,
		color: 'green'
	}, {
		name: '质检调拨返库中',
		value: 13,
		color: 'blue'
	}, {
		name: '质检驳回返库中',
		value: 14,
		color: 'red'
	}, {
		name: '质检驳回中',
		value: 16,
		color: 'red'
	}, {
		name: '维修调拨中',
		value: 21,
		color: 'blue'
	}, {
		name: '维修中',
		value: 22,
		color: 'green'
	}, {
		name: '维修返库中',
		value: 23,
		color: 'blue'
	}, {
		name: '维修驳回返库中',
		value: 24,
		color: 'red'
	}, {
		name: '维修驳回中',
		value: 26,
		color: 'red'
	}, {
		name: '销售调拨中',
		value: 31,
		color: 'blue'
	}, {
		name: '销售中',
		value: 32,
		color: 'green'
	}, {
		name: '销售返库中',
		value: 33,
		color: 'blue'
	}, {
		name: '销售驳回返库中',
		value: 34,
		color: 'red'
	}, {
		name: '销售驳回中',
		value: 36,
		color: 'red'
	}, {
		name: '采购退库',
		value: 41,
		color: 'gray'
	}, {
		name: '销售出库',
		value: 42,
		color: 'green'
	}, {
		name: '分润调拨出库',
		value: 43,
		color: 'blue'
	}],
	qualityStateDic: [{
		name: '待质检',
		value: 1,
		color: 'gray'
	}, {
		name: '已质检',
		value: 2,
		color: 'green'
	}, {
		name: '返库中',
		value: 3,
		color: 'orange'
	}, {
		name: '已返库',
		value: 4,
		color: 'red'
	}, {
		name: '已调出',
		value: 5,
		color: 'blue'
	}, {
		name: '调拨中',
		value: 8,
		color: 'orange'
	}, {
		name: '被驳回中',
		value: 9,
		color: 'red'
	}],
	qualityReportStateDic: [{
		name: '待添加',
		value: 0,
		color: 'gray'
	}, {
		name: '待发布',
		value: 1,
		color: 'blue'
	}, {
		name: '已发布',
		value: 2,
		color: 'green'
	}, {
		name: '已下架',
		value: 3,
		color: 'red'
	}],
	qualityReportPublishStateDic: [{
		name: '待发布',
		value: 1,
		color: 'blue'
	}, {
		name: '已发布',
		value: 2,
		color: 'green'
	}, {
		name: '已下架',
		value: 3,
		color: 'red'
	}],
	// 商品维度的维修环节进度，取数自后端函数 getHandoverRepairState(接驳ID)，与单据级的 repairRecordStateDic 不同义
	// 值域 1-5为维修进度，6返库中、7已返库、8已调出、9被驳回中、10调拨中，与函数返回值一致
	repairStateDic: [{
		name: '待维修',
		value: 1,
		color: 'gray'
	}, {
		name: '维修中',
		value: 2,
		color: 'orange'
	}, {
		name: '送修中',
		value: 3,
		color: 'green'
	}, {
		name: '维修+送修中',
		value: 4,
		color: 'blue'
	}, {
		name: '已维修',
		value: 5,
		color: 'blue'
	}, {
		name: '被驳回中',
		value: 9,
		color: 'red'
	}, {
		name: '返库中',
		value: 6,
		color: 'orange'
	}, {
		name: '已返库',
		value: 7,
		color: 'red'
	}, {
		name: '已调出',
		value: 8,
		color: 'blue'
	}, {
		name: '调拨中',
		value: 10,
		color: 'orange'
	}],
	deliveryRepairStateDic: [{
		name: '送修中',
		value: 1,
		color: 'gray'
	}, {
		name: '送修完成',
		value: 2,
		color: 'green'
	}],
	// 维修记录状态（1-维修中可改可删，2-维修完成后金额定稿不可改动）
	repairRecordStateDic: [{
		name: '维修中',
		value: 1,
		color: 'blue'
	}, {
		name: '维修完成',
		value: 2,
		color: 'green'
	}],
	// 销售商品总体状态
	saleOverallStateDic: [{
		name: '待上架',
		value: 1,
		color: 'gray'
	}, {
		name: '已上架',
		value: 2,
		color: 'green'
	}, {
		name: '已下架',
		value: 3,
		color: 'orange'
	}, {
		name: '锁定中',
		value: 4,
		color: 'red'
	}, {
		name: '已售出',
		value: 5,
		color: 'green'
	}],
	// 改价调整方式
	salePriceAdjustTypeDic: [{
		name: '单品改价',
		value: 1,
		color: 'blue'
	}, {
		name: '同SKU批量改价',
		value: 2,
		color: 'blue'
	}, {
		name: '统一金额调整',
		value: 3,
		color: 'orange'
	}, {
		name: 'Excel导入改价',
		value: 4,
		color: 'green'
	}],
	// 推送状态（与后端 PushRecordStateEnum 同口径：1待推送 2已受理 3推送失败 4推送成功 5已撤销）
	salePushStateDic: [{
		name: '待推送',
		value: 1,
		color: 'gray'
	}, {
		name: '已受理',
		value: 2,
		color: 'orange'
	}, {
		name: '推送失败',
		value: 3,
		color: 'red'
	}, {
		name: '推送成功',
		value: 4,
		color: 'green'
	}, {
		name: '已撤销',
		value: 5,
		color: 'gray'
	}],
	// 出价状态
	saleBidStateDic: [{
		name: '已出价',
		value: 1,
		color: 'blue'
	}, {
		name: '竞价成功',
		value: 2,
		color: 'green'
	}, {
		name: '竞价失败',
		value: 3,
		color: 'red'
	}],
	// 借出归还状态
	saleReturnStateDic: [{
		name: '借出中',
		value: 1,
		color: 'orange'
	}, {
		name: '已归还',
		value: 2,
		color: 'green'
	}],
	// 下架异常处理状态
	abnormalHandleStateDic: [{
		name: '待处理',
		value: 1,
		color: 'blue'
	}, {
		name: '已处理',
		value: 2,
		color: 'green'
	}],
	// 下架异常处理状态
	memberTypeDic: [{
		name: '企业账户',
		value: 2,
		color: 'blue'
	}, {
		name: '个人账户',
		value: 3,
		color: 'green'
	}],
	//银行卡类型
	bankCardProDic:[
		{name: '个人银行卡', value: 0, color: 'gray'},
		{name: '企业对公账户', value: 1, color: 'blue'}
	],
	//银行卡绑卡状态
	cardBindStateDic:[
		{name: '待绑定', value: 0, color: 'red'},
		{name: '已绑定', value: 1, color: 'green'},
		{name: '已解绑', value: 2, color: 'red'}
	],
	//入库数据展示类型
	showTypeDic:[
		{name: '按机型', value: 1, color: 'red'},
		{name: '按采购单', value: 2, color: 'green'}
	],
	//线下支付核销状态
	OFFLINE_PAY_CHECK_STATUS: [
		{name: '待核销', value: 0, color: 'orange'},
		{name: '已核销', value: 1, color: 'green'}
	],
	//线下支付方式
	OFFLINE_PAY_CHANNEL: [
		{name: '现金', value: 'offline_cash', color: 'blue'},
		{name: '收款码', value: 'offline_qr_code', color: 'green'},
		{name: '银行转账', value: 'offline_bank_card', color: 'yellow'}
	],
	yesOrNoOptions:[
		{name: '是',value: 1, color: 'green'},
		{name: '否',value: 2, color: ''},
	]
}